<template>
  <div class="icon-input">
    <div class="true-label"> {{ label }} </div>
    <input class="input" :class="{ 'input-error': error }" :type="type" :placeholder="placeholder" :value="value"
      @input="$emit('input', $event.target.value)">
    <label class="label-input">
      <slot> </slot>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'IconInput',
    props: ['type', 'placeholder', 'label', 'value', 'error']
  }
</script>

<style>
.true-label {
  color: #344054;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  /* 142.857% */
}

.icon-input {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input {
  padding: 10px 14px 10px 35px;
  border-radius: 8px;
  border: 1px solid #D0D5DD;
  background: #FFF;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  min-width: 300px;
  color: #344054;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  transition: border-color 0.3s ease-in-out;
  /* 171.429% */
}

.label-input {
  position: absolute;
  top: 38.5px;
  left: 10.5px;
}

.input-error {
  border: 1px solid #D92D20;
}

.input:focus-visible {
  outline: none;
  border: 1px solid #7F56D9;
}
</style>



// WEBPACK FOOTER //
// src/components/client/Inputs/IconInput.vue